import { render, staticRenderFns } from "./Plaque.vue?vue&type=template&id=fc8cc2be"
import script from "./Plaque.vue?vue&type=script&lang=js"
export * from "./Plaque.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports